import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';
import { msInboxApiUrl } from '../../../services/inbox/msInboxClient';
import { isInboxMsChat } from '../../../services/inbox/inboxMsChatPlatform';
import { resolveMsOutboundChatId, isInboxChatObjectId } from '../../../services/inbox/resolveOutboundRecipient';

// CSRF Token
const csrfToken = document.querySelector('[name=csrf-token]').content;

// Resources
const resource = `${MERCATELY_API_V2}/chat_actions/outbound`;

// Model
const model = abstractModel(resource);

model.sendMessage = async (body) => {
  let platform = '';

  if (body instanceof FormData) {
    platform = body.get('platform');
    const chatId = body.get('chat_id');
    const customerId = body.get('customer_id');
    if (isInboxMsChat(platform) || isInboxChatObjectId(chatId) || isInboxChatObjectId(customerId)) {
      const resolvedChatId = resolveMsOutboundChatId(chatId, customerId);
      if (resolvedChatId && !body.has('chat_id')) {
        body.append('chat_id', resolvedChatId);
      }
      return model.post(body, { path: msInboxApiUrl('/messages') });
    }
  } else if (body && typeof body === 'object') {
    platform = body.platform;
    const chatId = body.chat_id;
    const customerId = body.customer_id;
    if (isInboxMsChat(platform) || isInboxChatObjectId(chatId) || isInboxChatObjectId(customerId)) {
      const finalBody = { ...body };
      const resolvedChatId = resolveMsOutboundChatId(finalBody.chat_id, finalBody.customer_id);
      if (resolvedChatId) {
        finalBody.chat_id = resolvedChatId;
      }
      return model.post(finalBody, { path: msInboxApiUrl('/messages') });
    }
  }

  return model.post(body, { csrfToken });
};

export default model;
